import LegalLayout from './landing/LegalLayout';

function DataDeletion() {
  return (
    <LegalLayout title="Data Deletion Instructions" subtitle="for EFSoft">
      <p>
        At EFSoft, we respect your right to control your personal data. If you
        wish to have your data deleted from our systems, please follow these
        steps:
      </p>

      <section>
        <h2>Submit Your Request</h2>
        <p>
          Email us at{' '}
          <a href="mailto:emil.filip@efsoft.co.uk">emil.filip@efsoft.co.uk</a>{' '}
          with your full name, any associated account or reference information,
          and a clear statement requesting the deletion of your personal data.
        </p>
      </section>

      <section>
        <h2>Verification Process</h2>
        <p>
          To ensure the security of your information, we may ask you to verify
          your identity. This helps us confirm that the deletion request is
          legitimate.
        </p>
      </section>

      <section>
        <h2>Processing Your Request</h2>
        <p>
          After verifying your identity, we will proceed to delete your data
          from our active systems. Please note that some data may be retained as
          required by law, for accounting, or regulatory purposes.
        </p>
      </section>

      <section>
        <h2>Confirmation</h2>
        <p>
          We will notify you via email once your data has been successfully
          deleted.
        </p>
      </section>

      <section>
        <h2>Important Considerations</h2>
        <ul>
          <li>
            Data deletion might affect your access to certain services on our
            website.
          </li>
          <li>
            The process may take up to 30 days to complete, depending on the
            complexity of your request and any legal obligations we have.
          </li>
        </ul>
      </section>

      <div className="legal-callout">
        <p>
          If you have any questions or need further assistance regarding data
          deletion, please contact us at{' '}
          <a href="mailto:emil.filip@efsoft.co.uk">emil.filip@efsoft.co.uk</a>
        </p>
      </div>
    </LegalLayout>
  );
}

export default DataDeletion;
